import { ToneDto, ToneDtoImpl } from '../tonedto';
import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';
import { DateFormat } from '../../../ui/toolkit/dateformat/dateformat';
import { BaseContext } from '../../../utils/basecontext';

export class SearchToneBuilder {
    constructor(private searchToneList: any, private context: BaseContext) {
        if(searchToneList.searchList === undefined)
        {
            throw new NoDataException("Search Tone data doesnt exists");
        }
    }

    buildAll(): ToneDto[] {
        return this.parseSearchToneDetailsResponse();
    }

    private parseSearchToneDetailsResponse(): ToneDto[] {
        let listOfSearchTone: ToneDto[] = [];
        
        let toneDto = null;
        this.searchToneList.searchList.forEach((searchData: any) =>
        {
            toneDto = new ToneDtoImpl();
            toneDto.setId(searchData.toneId);
            toneDto.setImgPath(searchData.toneIdpreviewImageUrl);
            toneDto.setToneUrl(searchData.toneIdStreamingUrl);
            toneDto.setToneName(searchData.toneName);
            toneDto.setArtistName(searchData.artistName);
            toneDto.setAlbumName(searchData.albumName);
            toneDto.setPrice(searchData.price);
            toneDto.setCategoryId(searchData.categoryId);
            toneDto.setExpirydate(DateFormat.formatExpiryDate(searchData.expiryDate, this.context));
            toneDto.setLikeCount(searchData.likeCount);
            toneDto.setBaseCategoryId(searchData.baseCategoryId);
            
            listOfSearchTone.push(toneDto);
        });
        return listOfSearchTone;
    }



    /* private createDetailsResponse(): SearchToneDto[] {
        let listOfSearchTone: SearchToneDto[] = [];

        let searchToneResponse = null;
        let searchToneDetailsResponse = null;

        this.searchToneList.searchList.forEach((searchValue: any) => {
            searchToneResponse = new SearchToneDtoImpl();
            searchToneResponse.setCount(searchValue.count);

            let listOfSearchToneDetails: SearchToneDetailsDto[] = [];

            searchValue.toneDetails.forEach((toneValue: any) => {
                searchToneDetailsResponse = new SearchToneDetailsDtoImpl();
                searchToneDetailsResponse.setToneId(toneValue.toneId);
                searchToneDetailsResponse.setToneName(toneValue.toneName);
                searchToneDetailsResponse.setToneUrl(toneValue.toneUrl);
                searchToneDetailsResponse.setArtistName(toneValue.artistName);
                searchToneDetailsResponse.setPreviewImageUrl(toneValue.previewImageUrl);
                searchToneDetailsResponse.setPrice(toneValue.price);
                searchToneDetailsResponse.setPromocode(toneValue.promoCode);
                searchToneDetailsResponse.setCategoryId(toneValue.categoryId);
                searchToneDetailsResponse.setLikeCount(toneValue.likeCount);
                searchToneDetailsResponse.setBaseCategoryId(toneValue.baseCategoryId);

                listOfSearchToneDetails.push(searchToneDetailsResponse);
            });
            searchToneResponse.setSearchList(listOfSearchToneDetails);
            listOfSearchTone.push(searchToneResponse);
        });
        return listOfSearchTone;
    } */
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/searchtone/searchtonebuilder.ts